import React from 'react';

// A visual representation of Image 2 (Architecture) using CSS Grid
const ArchitectureView: React.FC = () => {
  return (
    <div className="p-8 h-full overflow-y-auto custom-scrollbar bg-slate-100">
      <div className="mb-8 text-center">
        <h2 className="text-3xl font-bold text-slate-800">AiQ | AiLabQuant Multi-asset Platform</h2>
        <p className="text-slate-600 mt-2">System Architecture Blueprint</p>
      </div>

      <div className="max-w-6xl mx-auto bg-white p-8 rounded-xl shadow-lg border border-slate-200">
        
        {/* Top Layer: Business Capabilities */}
        <div className="grid grid-cols-4 gap-4 mb-6 text-center">
          {['Collateral Management & Margin', 'HKTR Reporting', 'Valuation Center', 'Risk Center'].map((item) => (
             <div key={item} className="bg-blue-900 text-white py-3 rounded font-semibold shadow-sm text-sm md:text-base">
               {item}
             </div>
          ))}
        </div>

        {/* Middle Layer: Functional Modules */}
        <div className="grid grid-cols-12 gap-4 mb-6">
           {/* Business Applications (Left) */}
           <div className="col-span-3 bg-blue-50 border border-blue-200 p-3 rounded">
             <div className="bg-blue-600 text-white text-xs py-1 px-2 rounded mb-2 inline-block">Business Apps</div>
             <ul className="space-y-2 text-xs text-blue-900 font-medium">
               <li className="bg-white p-2 rounded border border-blue-100 shadow-sm">Risk Factor Mgmt</li>
               <li className="bg-white p-2 rounded border border-blue-100 shadow-sm">Volatility Surface</li>
               <li className="bg-white p-2 rounded border border-blue-100 shadow-sm">Model Calibration</li>
               <li className="bg-white p-2 rounded border border-blue-100 shadow-sm">Margin Analysis</li>
             </ul>
           </div>

           {/* Core Engine (Center) */}
           <div className="col-span-6 bg-slate-50 border-2 border-dashed border-slate-300 p-4 rounded flex flex-col gap-4">
             <div className="text-center font-bold text-slate-700 uppercase tracking-wider text-sm">AiQ Unified Data & Calculation Engine</div>
             
             <div className="grid grid-cols-2 gap-4 flex-1">
               <div className="bg-white p-3 rounded shadow-sm border border-slate-200 flex flex-col justify-center items-center text-center">
                 <div className="font-bold text-slate-800 text-sm">Trade Repository</div>
                 <div className="text-[10px] text-slate-500 mt-1">Standardized Lifecycle</div>
               </div>
               <div className="bg-white p-3 rounded shadow-sm border border-slate-200 flex flex-col justify-center items-center text-center">
                 <div className="font-bold text-slate-800 text-sm">Quant Engine</div>
                 <div className="text-[10px] text-slate-500 mt-1">Pricing / Greeks / VaR</div>
               </div>
               <div className="bg-white p-3 rounded shadow-sm border border-slate-200 flex flex-col justify-center items-center text-center">
                 <div className="font-bold text-slate-800 text-sm">Market Data</div>
                 <div className="text-[10px] text-slate-500 mt-1">Curves / Surfaces</div>
               </div>
               <div className="bg-white p-3 rounded shadow-sm border border-slate-200 flex flex-col justify-center items-center text-center">
                 <div className="font-bold text-slate-800 text-sm">Ref Data</div>
                 <div className="text-[10px] text-slate-500 mt-1">Counterparty / Calendar</div>
               </div>
             </div>
           </div>

           {/* Reporting & Monitoring (Right) */}
           <div className="col-span-3 bg-emerald-50 border border-emerald-200 p-3 rounded">
             <div className="bg-emerald-600 text-white text-xs py-1 px-2 rounded mb-2 inline-block">Monitoring</div>
             <ul className="space-y-2 text-xs text-emerald-900 font-medium">
               <li className="bg-white p-2 rounded border border-emerald-100 shadow-sm">Limits Monitor</li>
               <li className="bg-white p-2 rounded border border-emerald-100 shadow-sm">Exception Mgmt</li>
               <li className="bg-white p-2 rounded border border-emerald-100 shadow-sm">Audit Trail</li>
               <li className="bg-white p-2 rounded border border-emerald-100 shadow-sm">Regulatory Reports</li>
             </ul>
           </div>
        </div>

        {/* Bottom Layer: External Connectivity */}
        <div className="border-t-2 border-slate-100 pt-6">
          <div className="text-center text-slate-400 text-xs font-bold uppercase mb-4">External Systems Connectivity</div>
          <div className="grid grid-cols-4 gap-4">
            <div className="bg-slate-800 text-slate-300 py-2 rounded text-center text-xs font-mono">Bloomberg / Refinitiv</div>
            <div className="bg-slate-800 text-slate-300 py-2 rounded text-center text-xs font-mono">Internal Booking (Murex/Calypso)</div>
            <div className="bg-slate-800 text-slate-300 py-2 rounded text-center text-xs font-mono">Market Infrastructure (HKEX/OTC)</div>
            <div className="bg-slate-800 text-slate-300 py-2 rounded text-center text-xs font-mono">Regulatory Bodies</div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ArchitectureView;